/* Bedtextielonline (Claude): productpagina compacter, vooral op de gsm.
   - Overal: 'Hulp bij je maat' wordt een klein knopje 'Welke maat?' naast 'Afmeting' (opent dezelfde maatgids); de hoekhoogte blijft als korte regel.
   - Op gsm en computer dezelfde volgorde: 'Terug naar ...' als pilletje boven de foto's; het actieblok '2e dekbedovertrek'
     en 'Vaak gecombineerd met' onder de knop; de vinkjes (stof, instopstrook, wassen ...) helemaal onderaan in de productinfo.
   Wordt geladen vanuit snippets/btol-pdp-vinkjes.liquid. */
(function () {
  if (window.__btolPdpGsm) return;
  window.__btolPdpGsm = true;

  var st = document.createElement('style');
  st.textContent =
    /* maathulp: groot veld weg, knopje naast 'Afmeting' */
    '.product-info__block-item:has(> .liquid > .btol-mh){margin:0!important}' +
    '.btol-mh.btol-mh--klein{display:none!important}' +
    '.btol-mh-legend{display:flex!important;align-items:center;justify-content:space-between;gap:10px;width:100%}' +
    '.btol-mh-tip{display:inline-flex;align-items:center;gap:6px;min-height:32px;padding:0 12px 0 10px;border:0;border-radius:999px;background:#EEF0FA;color:#2F2A44;font:inherit;font-size:13.5px;font-weight:600;letter-spacing:0;text-transform:none;cursor:pointer;transition:background-color .15s ease}' +
    '.btol-mh-tip svg{width:16px;height:16px;flex:0 0 16px}' +
    '@media (hover:hover){.btol-mh-tip:hover{background:#DADDFB}}' +
    '.btol-mh-hoek{margin:2px 0 0;font-size:14px;line-height:1.4;color:rgba(47,42,68,.75)}' +
    '.btol-mh-hoek strong{color:#2F2A44}' +
    /* volgorde in de productinfo (gsm en computer gelijk) */
      '.product-info__block-list{display:flex;flex-direction:column}' +
      '.product-info__block-list > *{margin-bottom:0!important}' +
      '.product-info__block-list > .btol-a2{order:1}' +
      '.product-info__block-list > [data-block-type="complementary-products"]{order:2}' +
      '.product-info__block-list > .product-info__block-item:has(> .liquid > .btol-vink){order:3}' +
      '.product-info > .btol-terug-top{display:none!important}' +
      'product-gallery > .btol-terug-top{order:-1;align-self:flex-start;display:inline-flex!important;align-items:center;gap:6px;margin:0 0 -12px!important;min-height:34px;padding:0 14px 0 10px;border-radius:999px;background:#EEF0FA;color:#2F2A44!important;font-size:14px!important;font-weight:600;text-decoration:none!important}' +
      '@media (hover:hover){product-gallery > .btol-terug-top:hover{background:#DADDFB}}';
  document.head.appendChild(st);

  var gsm = { matches: true };
  var PIJL = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  var LAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 15.5 15.5 3 21 8.5 8.5 21z"/><path d="m7 12 1.5 1.5M10 9l2 2M13 6l1.5 1.5"/></svg>';

  function terug() {
    var link = document.querySelector('.btol-terug-top');
    var gal = document.querySelector('product-gallery');
    if (!link || !gal) return;
    if (!link.__btolTekst) {
      link.__btolTekst = link.textContent.replace(/^\s*←\s*/, '').trim();
      link.__btolThuis = link.parentNode;
      link.__btolVoor = link.nextSibling;
    }
    if (gsm.matches) {
      if (link.parentNode !== gal) {
        link.innerHTML = PIJL + '<span>' + link.__btolTekst + '</span>';
        gal.insertBefore(link, gal.firstChild);
      }
    } else if (link.parentNode === gal) {
      link.textContent = '← ' + link.__btolTekst;
      link.__btolThuis.insertBefore(link, link.__btolVoor && link.__btolVoor.parentNode === link.__btolThuis ? link.__btolVoor : link.__btolThuis.firstChild);
    }
  }

  function maatVeld() {
    var vp = document.querySelector('variant-picker[context="main_product"]') || document.querySelector('.product-info variant-picker');
    if (!vp) return null;
    var sets = vp.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && /maat|afmeting|size/i.test(lg.textContent)) return sets[i];
    }
    return null;
  }

  function maathulp() {
    var groot = document.querySelector('.btol-mh[data-btol-maatgids-open]');
    var veld = maatVeld();
    if (!groot || !veld) return;
    var lg = veld.querySelector('legend');
    if (lg.querySelector('.btol-mh-tip')) return;
    groot.classList.add('btol-mh--klein');
    var label = document.createElement('span');
    while (lg.firstChild) label.appendChild(lg.firstChild);
    lg.appendChild(label);
    lg.classList.add('btol-mh-legend');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'btol-mh-tip';
    b.setAttribute('data-btol-maatgids-open', groot.getAttribute('data-btol-maatgids-open'));
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = LAT + '<span>Welke maat?</span>';
    lg.appendChild(b);
    var hoek = Array.prototype.filter.call(groot.querySelectorAll('small'), function (s) { return /hoekhoogte/i.test(s.textContent); })[0];
    if (hoek && !veld.querySelector('.btol-mh-hoek')) {
      var p = document.createElement('p');
      p.className = 'btol-mh-hoek';
      p.innerHTML = hoek.innerHTML;
      lg.insertAdjacentElement('afterend', p);
    }
  }

  function alles() { terug(); maathulp(); }
  var wacht = null;
  function straks() { clearTimeout(wacht); wacht = setTimeout(alles, 40); }
  function start() {
    if (!document.querySelector('product-gallery')) return;
    alles();
    var info = document.querySelector('.product-info') || document.body;
    if (window.MutationObserver) new MutationObserver(function () {
      var v = maatVeld();
      if (v && !v.querySelector('.btol-mh-tip')) maathulp(); else straks();
    }).observe(info, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();